'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

// -----------------------------------------------------------
//  SelectedOptionButton
// -----------------------------------------------------------
const SelectedOptionButton = props => {
  const handleClearClicked = (debounce(() => {
    props.onClearClick(props.filterName, props.title, false);
  }, 200));

  return (
    <div className="mx-1 my-1">
      <button className="btn bg-white btn-selection-option" key={props.title}
        role='button'
        data-dismiss="modal"
        aria-label={`${props.title} Close`}
        onClick={handleClearClicked}
      >
        {props.title}
        <i
          className="close-button skinny-icon close mt-1"
          aria-label="Close"
          onClick={handleClearClicked}></i>
      </button>
    </div>
  );
};

SelectedOptionButton.propTypes = {
  title: PropTypes.string,
  onClearClick: PropTypes.func,
  filterName: PropTypes.string,
};

export default SelectedOptionButton;
